import React from 'react';
import { detailCardClass, detailItemClass, sectionTitleClass, secondaryButtonClass } from './ui';

const formatPacificDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  }).format(date);
};

const formatFieldValue = (value) => {
  if (value === null || typeof value === 'undefined') return '-';
  if (Array.isArray(value)) return value.length ? value.join(', ') : '[]';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

const labelFromKey = (key) => {
  if (!key) return key;
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (char) => char.toUpperCase());
};

const isUuid = (value) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || '')
  );

const ApplicationDetails = ({ application, onUpdate, onShowUsers }) => {
  const entries = Object.entries(application || {});

  return (
    <div className={detailCardClass}>
      <h4 className={`${sectionTitleClass} mb-2`}>Application Details</h4>
      <div className="grid grid-cols-1 gap-2 text-xs text-slate-700 md:grid-cols-2">
        {entries.map(([key, value]) => (
          <div key={key} className={detailItemClass}>
            <span className="font-medium text-slate-800">{labelFromKey(key)}:</span>{' '}
            <span className={`text-slate-700 ${isUuid(value) ? 'font-mono' : ''}`}>
              {key.endsWith('At') ? formatPacificDateTime(value) : formatFieldValue(value)}
            </span>
          </div>
        ))}
      </div>
      {(typeof onUpdate === 'function' || typeof onShowUsers === 'function') && (
        <div className="mt-3 flex gap-2">
          {typeof onShowUsers === 'function' && (
            <button
              type="button"
              onClick={onShowUsers}
              className={secondaryButtonClass}
            >
              Show Users
            </button>
          )}
          {typeof onUpdate === 'function' && (
            <button
              type="button"
              onClick={onUpdate}
              className={secondaryButtonClass}
            >
              Update
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ApplicationDetails;
